import React from 'react'
import { View } from 'react-native'
import Text from '../Txt'

const DemoError = () => {
  return (
    <View style={{ flex: 1, justifyContent: 'center', alignItems: 'center' }}>
      <Text text='We are sorry!' style={{ fontSize: 32, marginBottom: 25 }} />
      <Text text='We are actually working on this demo platform. It will be back on soon.' style={{ fontSize: 14, width: 470 }} />
    </View>
  )
}
export default DemoError
